import { render, staticRenderFns } from "./InstagramView.vue?vue&type=template&id=5100a669&"
import script from "./InstagramView.vue?vue&type=script&lang=js&"
export * from "./InstagramView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports